import { Component, OnInit } from '@angular/core';
import { PatientServiceService } from '../../services/PatientService.service';
import { PatientCaseListDataModel } from '../../models/PatientCaseListData.model';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
declare var $: any;
@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})

export class PaFeedbackComponent implements OnInit {
  htmlView: boolean = true;
  errHeader: string;
  errMessage: string[] = [];
  score: number = 0;
  displayRatingScore = 4;
  showFeedback = false;
  cases: any[];
  scheduledInfo: any;
  caseName: string;
  docId: string;
  scheduleDate: string;
  caseList: PatientCaseListDataModel[];
  currentListShow: boolean = false;
  showOverlayFeedback: boolean;
  scheduledId: string;
  scheduledBy: string;
  eaHospId: string;
  constructor(private _service: PatientServiceService) { }

  ngOnInit() {
    this.showOverlayFeedback = true;
    this.getPatientCases();
  }

  routeBack() {
    this.scheduledId = "";
    this.scheduledBy = "";
    this.caseName = "";
    this.docId = "";
    this.eaHospId = "";
    this.scheduleDate = "";
    this.showFeedback = !this.showFeedback;
  }

  onRateChange(score) {
    this.score = score;
  }

  getPatientCases() {
    this._service.getPatientCaseList().subscribe((data: any[]) => {
      this.cases = data.filter(ij => ij.isCompleted == true);
      this.showOverlayFeedback = false;
      if (this.cases.length < 1) {
        this.currentListShow = true;
      } else {
        this.cases.forEach(i => {
          var fromDate = new Date(i.frmDate);
          i.fromDate = fromDate.getDate() + "-" + (1 + parseInt(fromDate.getMonth().toString())) + "-" + fromDate.getFullYear();
        })
        this.currentListShow = false;
      }
    }, err => {
      if (err.status === 400) {
        this.errHeader = 'Server Exception';
        this.errMessage = err.error;
        this.htmlView = false;
      }
      this.showOverlayFeedback = false;
    }, () => {
      this.htmlView = true;
      this.showOverlayFeedback = false;
    });
  }

  onEventFeedback(data) {
    data.evt.stopPropagation();
    this.goToFeedback(data.caseId, data.scheduler, data.caseName, data.docId, data.hospId, data.date);
  }

  goToFeedback(scheduledId, scheduledBy, caseName, docId, eaHospId, schDate) {
    this.scheduledId = scheduledId;
    this.scheduledBy = scheduledBy;
    this.caseName = caseName;
    this.docId = docId;
    this.eaHospId = eaHospId;
    this.scheduleDate = schDate;
    this.showFeedback = !this.showFeedback;

  }

  onEventView(data) {
    data.evt.stopPropagation();
    this.getPatientScheduledInfo(data.caseId);
  }

  getPatientScheduledInfo(sId) {
    $("#scheduleModal").modal('show');
    for (let v of this.cases) {
      v.borderLeft = "";
      v.borderRight = "";
      v.borderBottom = "";
    }
    let index1 = this.cases.findIndex(a => a.sId == sId);
    this.cases[index1].borderLeft = "2px solid #0969c9";
    this.cases[index1].borderRight = "2px solid #0969c9";
    this.cases[index1].borderBottom = "2px solid #0969c9";
    this._service.getPatientScheduledInfo(sId).subscribe((data: any) => {
      this.scheduledInfo = data;
    });
  }

  addFeedback(feedbackText) {
    if ((feedbackText == "" || feedbackText == null || feedbackText == undefined) || this.score == 0) {
       this.alertClose();
      AlertMessages.Show("Warning", 'Please Give Feeback Text and Rating', AlertType.Warning);
    } else {
      this._service.feedbackFromPatient(this.scheduledId, feedbackText, this.score, this.docId, this.eaHospId).subscribe(
        (data) => {
        this.alertClose();
        this.routeBack();
        AlertMessages.Show("Success", 'Feedback Sent', AlertType.Success);
      });
    }
  }

  alertClose() {
    setTimeout(() => {
    }, 3000);
  }

}
